import { styled } from "@mui/material"

export const Wrapper = styled("div")(() => ({
  margin: 16,
}))
